import React, { useMemo } from "react";
import { useGetPayment } from "../apiHooks";
import DescriptionList from "../../../components/molecules/DescriptionList";
import Loader from "components/atoms/Loader";
import { PaymentDataType } from "modules/payments/types";

const Info = ({ id }: any) => {
  const { data, isLoading } = useGetPayment(id);
  const listData: any = useMemo(() => {
    const res = [];
    let key: keyof PaymentDataType;
    for (key in data) {
      res.push({ title: [key], value: data?.[key] });
    }
    return res;
  }, [data]);
  if (isLoading) {
    return <Loader formOverlay />;
  }
  return <DescriptionList list={listData} />;
};

export default Info;
